import { actions } from './writeOff/actions'
import { getters } from './writeOff/getters'
import { state } from './writeOff/state'
import { mutations } from './writeOff/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
